import PropTypes from 'prop-types';
import classNames from 'classnames';

import style from './index.module.scss';

const ProgressBar = ({
  total,
  current,
  title,
  startText,
  endText,
  currentText,
  forceAnimation,
  rounded,
}) => {
  let widthPercentage = ((current * 100) / total).toFixed(2);

  const percentage = widthPercentage;

  if (percentage > 100) {
    widthPercentage = 100;
  }

  return (
    <div>
      {title && (
        <h5 className="uk-heading-primary push-double--bottom">{title}</h5>
      )}
      <div className={style.bar} title={`${percentage}%`}>
        <div className={`weight--semibold ${style['start-text']}`}>
          {startText}
        </div>
        {current !== 0 && current < total && (
          <div
            className={`weight--semibold ${style['current-text']}`}
            style={{ left: `${widthPercentage}%` }}
          >
            {currentText}
          </div>
        )}
        <div className={`weight--semibold ${style['total-text']}`}>
          {endText}
        </div>
        <div
          className={classNames(style.background, {
            [style.rounded]: rounded,
          })}
        />
        <div
          className={classNames(style.active, {
            [style.rounded]: rounded,
          })}
          style={{
            width: `${widthPercentage}%`,
          }}
        >
          {(current < total || forceAnimation) && (
            <span
              className={classNames(style.animation, {
                [style.rounded]: rounded,
              })}
            />
          )}
        </div>
      </div>
    </div>
  );
};

ProgressBar.protoTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  title: PropTypes.string,
  startText: PropTypes.string,
  endText: PropTypes.string,
  currentText: PropTypes.string,
  forceAnimation: PropTypes.bool,
  rounded: PropTypes.bool,
};

ProgressBar.defaultProps = {
  forceAnimation: false,
  rounded: false,
};

export default ProgressBar;
